import { AxiosResponse } from "axios";
import instance from "../instance";
import {
  ProfGroupInterface,
  ProfGroupDetailInterface,
} from "@/core/reatom/state/profGroups";

export const getProfGroups = async (): Promise<ProfGroupInterface[] | null> => {
  try {
    const res: AxiosResponse<{ items: ProfGroupInterface[] }> =
      await instance.get("/v1/prof_groups");
    return res.data.items;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getProfGroupsDetail = async (): Promise<
  ProfGroupDetailInterface[] | null
> => {
  try {
    const res: AxiosResponse<{ items: ProfGroupDetailInterface[] }> =
      await instance.get("/v1/prof_groups/professions");
    return res.data.items;
  } catch (error) {
    console.error(error);
    return null;
  }
};
